/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const ColStyledHighlightContainer = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const smallUp = theme.smallUp();
    let thisRightPadding = rem(15);

    if(mediumUp){
      thisRightPadding = 0;
    } else if(smallUp){
      thisRightPadding = rem(25);
    }

    return css`
      padding-left: 0;
      padding-right: ${thisRightPadding};
    `;
  }}
`;

export const ColStyled = styled(Col)`
  ${({ theme, disableBottomPadding }) => {
    const mediumUp = theme.mediumUp();
    let horizontalPadding = 0;

    if(mediumUp){
      horizontalPadding = rem(12);
    }

    return css`
      margin-bottom: ${(mediumUp || disableBottomPadding) ? 0 : rem(24)};
      padding-left: ${horizontalPadding};
      padding-right: ${horizontalPadding};
    `;
  }}
`;

export const RowStyled = styled(Row)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    let thisPaddingBottom = rem(32);

    if(mediumUp){
      thisPaddingBottom = rem(40);
    }

    return css`
      padding-bottom: ${thisPaddingBottom};
    `;
  }}
`;

export const TypographyStyled = styled(Typography)`
  color: inherit;
`;

